import React from 'react'
import moment from 'moment'
import { FaArrowLeft, FaArrowRight, FaTimes } from 'react-icons/fa'
import { Link } from 'react-router-dom'

interface Props {
	transactions: any[],
	state?: any
}

const TransactionList: React.FC<Props> = ({ state, transactions }) => {
	return (
		<table className="text-left w-full text-sm">
			<thead className="border-b bg-offWhite">
				<tr>
					<th></th>
					<th className="p-2">
						Name
							</th>
					<th className="p-2">
						Consultant Code
							</th>
					<th className="p-2">
						Date
							</th>
					<th className="p-2">
						Amount
							</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				{
					transactions.map(t => (
						<tr className="border-t" key={t.id.toString()}>
							<td className={`p-2 w-2 ${t.status === 3 ? 'opacity-25' : ''}`}>
								{t.status === 3 ? <FaTimes className="text-gray-900" /> : t.amount >= 0 ? <FaArrowRight className="text-blue-600" /> : <FaArrowLeft className="text-red-600" />}
							</td>
							<td className={`p-2  ${t.status === 3 ? 'opacity-25' : ''}`}>
								{t.userName}
							</td>
							<td className={`p-2  ${t.status === 3 ? 'opacity-25' : ''}`}>
								{t.consultantCode}
							</td>
							<td className={`p-2  ${t.status === 3 ? 'opacity-25' : ''}`}>
								{moment(t.transactionDate.toDate()).format('YYYY-MM-DD hh:mm:ss A')}
							</td>
							<td className={`p-2  ${t.status === 3 ? 'opacity-25' : ''}`}>
								{t.status === 3 ? 'Rejected' : t.status === 1 ? 'Pending' : t.amount}
							</td>
							<td className="text-right p-2">
								{
									t.status === 1 ? (
										<Link to={{ pathname: `transactions/${t.id}`, state }}>
											<button className="bg-indigo-600 hover:bg-indigo-800 h-6 text-xs">Approve</button>
										</Link>
									) : (
											<Link to={{ pathname: `transactions/${t.id}`, state }}>
												<button className="bg-gray-500 hover:bg-gray-600 h-6 text-xs">Edit</button>
											</Link>
										)
								}
							</td>
						</tr>
					))
				}
			</tbody>
		</table >
	)
}

export default TransactionList
